import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { InfoPageRoutingModule } from './info-page-routing.module';
import { ServicesModule } from 'world-archery-lib';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    InfoPageRoutingModule,
    ServicesModule
  ]
})
export class InfoPageModule { }
